import { render } from "./TripCardItem.vue?vue&type=template&id=aa8d3c34"
import script from "./TripCardItem.vue?vue&type=script&lang=js"
export * from "./TripCardItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__